<template>
  <div class="foot">
    <div class="prompt" v-show="isShowImgMsg">
      <p>BMP, PNG, JPG up to 30MB each</p>
      <span></span>
    </div>
    <template v-if="isShowOcclusionLayer">
      <el-tooltip class="item" effect="dark" content="No permission to chat with this user" placement="top">
        <div class="noMicrophone occlusion-layer"></div>
      </el-tooltip>
    </template>
    <!-- 语音没有权限 -->
    <div class="noMicrophone" v-show="isShowNoMicrophone">
      <!-- <span>Unable to access microphone, please check system settings</span> -->
      <span>No microphone permission, click <u @click="sendVoice">here</u> to get permission</span>
      <p @click="cancel">Cancel</p>
      <p style="color: rgba(0, 0, 0, 0); cursor: default">Cancel</p>
    </div>
    <!-- 语音 -->
    <div class="voice-send" v-show="sendVoiceStatus">
      <div class="text-nor" @click="returnInput">Cancel</div>
      <div class="nor">
        <img
          src="@/assets/img/im-icon/voice-send.png"
          @click="playSendVoice"
          alt=""
        />
      </div>
      <div class="time"></div>
    </div>
    <!-- sendVoiceplay -->
    <div class="voice-send" v-show="sendVoiceplay">
      <div
        class="text-nor"
        style="font-size: 14px; color: #4066d4"
        @click="returnPlaySendVoice"
      >
        Cancel
      </div>
      <div
        class="nor"
        @click="startSend"
        :style="
          percentages >= 100 && start
            ? 'background:#4066d4;'
            : 'background:#e6effc;'
        "
      >
        <img
          src="@/assets/img/im-icon/send-fff.svg"
          v-if="percentages >= 100 && start"
          alt=""
        />
        <img src="@/assets/img/im-icon/send-sel-audio.svg" v-else alt="" />
        <template @click="endSend()">
          <el-progress
            type="circle"
            v-show="start"
            :percentage="percentages"
            color="#4066d4"
            :show-text="false"
          ></el-progress>
        </template>
      </div>
      <div class="time">
        <div v-show="start">
          <span class="timeRas" v-if="percentages === 100"></span>
          <span class="timeRa" v-else></span>

          <p>
            0:<span class="times">{{ Math.round(time) }}</span
            >s
          </p>
        </div>
      </div>
    </div>
    <!-- 输入框 -->
    <el-input
      @keydown.enter.native="ctrlEnter($event, content)"
      class="input"
      resize="none"
      maxlength="4999"
      type="textarea"
      :autosize="{ minRows: 1, maxRows: 3 }"
      placeholder="Type a message here…"
      v-model="content"
    >
    </el-input>
    <!-- 按钮 -->
    <div class="btn">
      <div class="voice-img">
        <div class="sendImg voice">
          <!-- <img :src="sendVoiceImg"  @click="sendVoice" /> -->
          <svg
            @click="sendVoice"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <g fill="none" fill-rule="evenodd">
              <g>
                <g>
                  <g>
                    <path
                      fill="#FFF"
                      fill-opacity="0"
                      d="M0 0H24V24H0z"
                      transform="translate(-948.000000, -562.000000) translate(40.000000, 488.000000) translate(908.000000, 74.000000)"
                    />
                    <path
                      fill="currentColor"
                      d="M15 19.5c.552 0 1 .448 1 1s-.448 1-1 1H9c-.552 0-1-.448-1-1s.448-1 1-1h6zm-8.5-9c.513 0 .936.386.993.883l.007.117v.248c0 2.634 2.025 4.752 4.5 4.752 2.406 0 4.387-2.002 4.495-4.534l.005-.218v-.226c0-.553.448-1 1-1 .513 0 .936.386.993.883l.007.117v.226c0 3.72-2.9 6.752-6.5 6.752-3.524 0-6.376-2.905-6.496-6.516l-.004-.236V11.5c0-.552.448-1 1-1zm5.5-8c1.657 0 3 1.343 3 3v6c0 1.657-1.343 3-3 3s-3-1.343-3-3v-6c0-1.657 1.343-3 3-3z"
                      transform="translate(-948.000000, -562.000000) translate(40.000000, 488.000000) translate(908.000000, 74.000000)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </div>
        <div
          class="sendImg"
          ref="sendImg"
          @mouseover="imgOver"
          @mouseleave="imgLeave"
        >
          <svg
            class="sendImg"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <g fill="none" fill-rule="evenodd">
              <g>
                <g>
                  <g>
                    <path
                      fill="currentColor"
                      fill-opacity="0"
                      d="M0 0H24V24H0z"
                      transform="translate(-1356.000000, -842.000000) translate(412.000000, 808.000000) translate(944.000000, 34.000000)"
                    />
                    <path
                      fill="currentColor"
                      d="M19 4c1.105 0 2 .895 2 2v12c0 1.105-.895 2-2 2H5c-1.105 0-2-.895-2-2V6c0-1.105.895-2 2-2h14zm-1.354 7.308c-.366-.385-.95-.413-1.348-.064L11 15.894l-2.445-1.717c-.336-.236-.774-.236-1.11 0L5 15.894v1.053C5 17.529 5.448 18 6 18h12c.552 0 1-.471 1-1.053v-4.212zM8 7c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2z"
                      transform="translate(-1356.000000, -842.000000) translate(412.000000, 808.000000) translate(944.000000, 34.000000)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
          <label id="files">
            <input
              type="file"
              class="uploadFiles"
              id="files"
              @change="fileImage()"
              ref="imageInput"
              Name=""
              accept="image/png,image/jpeg,image/jpg,/image/BMP"
            />
          </label>
        </div>
      </div>
      <button class="send" @click="sendInfo(content)">
        <img v-if="content === ''" :src="sendImg" class="image" />
        <img v-if="content" :src="sendImgAfter" class="image" />
      </button>
    </div>
  </div>
</template>

<script>
import chatinputMixins from "@/im/components/mixins/chatinput";

export default {
  name: "chatInput.vue",
  mixins: [chatinputMixins]
};
</script>
<style lang="scss" scoped>
.foot {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #fff;

  /deep/ .el-textarea {
    flex: 1;
    height: auto;
    margin-bottom: 16px;
    max-height: 60px;
    font-size: 14px !important;
    font-weight: 500;
    color: #000;
    display: flex;
    align-items: center;
    overflow-y: auto;

    textarea {
      background: rgba(0, 0, 0, 0);
      border: none;
      width: 100%;
      font-weight: 500;
      line-height: 1.43;
      padding: 0;
      outline: none;
      font-size: 14px;
      color: #000;
      min-height: 0 !important;
      font-weight: 500;

      &::-webkit-scrollbar {
        display: block;
        width: 4px;
        height: 100%;
        border-radius: 2px;
        background: rgba(0, 0, 0, 0);
      }

      &::-webkit-scrollbar-thumb {
        width: 4px;
        border-radius: 2px;
        background: #dadce1;
      }

      &::placeholder {
        font-weight: 500;
        color: #7f8596;
      }
    }
  }
  .prompt {
    width: 208px;
    height: 41.7px;
    position: absolute;
    bottom: 47px;
    left: 0px;
    display: flex;
    z-index: 200;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    // padding: 10px 10px 5.7px 0;
    background-color: rgba(0, 15, 36, 0.8);
    p {
      font-weight: 500;
      font-size: 12px;
      line-height: 1.33;
      color: #ffffff;
    }
    span {
      position: absolute;
      width: 0px;
      height: 0px;
      line-height: 0px;
      border-top: 8px solid rgba(0, 15, 36, 0.8);
      border-left: 8px solid #fff;
      border-right: 8px solid #fff;
      left: 40px;
      bottom: -8px;
    }
  }
  .noMicrophone {
    width: 100%;
    height: 100%;
    background: #ffff;
    position: absolute;
    left: 0;
    z-index: 88;
    top: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    display: flex;
    flex-direction: column;

    span {
      flex: 1;
      font-weight: 500;
      font-weight: 500;
      color: #000c2e;
      font-size: 14px;
      display: block;
      margin-bottom: 4px;
    }
    i {
      font-style: normal;
    }
    i:hover {
      cursor: pointer;
    }

    u {
      cursor: pointer;
      color: #4066d4;
      font-weight: 500;
      font-weight: 500;
      font-size: 14px;
    }

    p {
      color: #4066d4;
      font-weight: 500;
      font-weight: 500;
      font-size: 14px;
      align-self: flex-start;
    }
    p:hover {
      cursor: pointer;
    }
  }
  .occlusion-layer {
    background-color: transparent;
  }
  .voice-send {
    height: 100%;
    width: 100%;
    background: #fff;
    position: absolute;
    left: 0;
    z-index: 87;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .text-nor {
      cursor: pointer;
      font-weight: 500;
      color: #4066d4;
      line-height: 1.43;
      font-weight: 500;
      font-size: 14px;
    }
    .nor {
      background: rgba(#4066d4, .2);
      width: 48px;
      height: 48px;
      position: relative;
      //  background:#e6effc;
      border-radius: 48px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 24px;
        height: 24px;
      }

      .el-progress {
        width: 48px;
        height: 48px;
        left: 0;
        top: 0;
        position: absolute;
      }
    }

    .time {
      width: 52px;
      height: 20px;

      div {
        display: flex;
        align-items: center;

        .timeRa {
          width: 8px;
          height: 8px;
          margin-right: 8px;
          border-radius: 50%;
          background-color: #cf1322;
          animation-name: Flashing;
          animation-duration: 1.5s;
          animation-iteration-count: infinite;
        }

        .timeRas {
          width: 6px;
          height: 6px;
          margin: 0 6px 0 0;
          border-radius: 50%;
          background-color: #cf1322;
        }

        p {
          font-size: 14px;
          line-height: 1.43;
          color: #000;
          font-family: OpenSans;
        }

        @keyframes Flashing {
          0% {
            opacity: 0;
          }
          75% {
            opacity: 1;
          }
          100% {
            opacity: 0;
          }
        }
      }
    }
  }
  .input {
    flex: 1;
  }
  .btn {
    width: 100%;
    // background: red;
    display: flex;
    // flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    // .prompt {
    // }

    .voice-img {
      width: auto;
      display: flex;
      justify-content: space-between;

      > div {
        width: 24px;
        overflow: hidden;

        &:nth-of-type(2) {
          margin-left: 12px;
        }
      }
    }

    

    > button {
      width: 24px;
    }
  }
  // .sendBtn {
  //   display: flex;
  //   align-items: flex-end;

  .sendImg {
    height: 24px;
    position: relative;
    cursor: pointer;
    color: currentColor;

    input {
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      opacity: 0;
      z-index: 20;
      position: absolute;
    }

    &:hover {
      color: #4066d4;
    }
  }
  .voice {
    color: #000;
  }

  .sendVoiceImg:hover {
    background: #eef0f3;
  }
  .voice:hover {
    color: #4066d4;
  }

  img {
    cursor: pointer;
  }
  // }
}
button {
  border: 0;
  outline: none;
  background: none;
  border-radius: 0;
  text-align: center;
}

.send {
  display: flex;
  align-items: flex-end;
}

.uploadFiles {
  cursor: pointer;

  &::-webkit-file-upload-button {
    cursor: pointer;
  }
}
</style>
